import React from 'react';
import styled from 'styled-components';
import CriteriaImage from 'CriteriaImage';
import { rhythm } from 'Themes/typography';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;
const Desc = styled.p`
  font-size: 0.875rem;
  margin-bottom: ${rhythm(0.5)};
`;

const Name = styled.h3`
  // font-size: 1rem;
  color: ${({ theme }) => theme.palette.secondary.main};
  margin-bottom: 5px;
`;

const LocationOnplan = styled.h4`
  color: ${({ theme }) => theme.palette.secondary.main};
  margin-bottom: 0 !important;
`;

const TextWrapper = styled.div`
  margin-left: 10px;
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const TicketReference = ({ name, iconCombination, locationOnPlan }) => (
  <Container>
    <CriteriaImage iconCombination={iconCombination} />
    <TextWrapper>
      {/* <Desc>Ticket reference:</Desc> */}
      <FlexColumn>
        <Name>{name}</Name>
        <LocationOnplan>{locationOnPlan}</LocationOnplan>
      </FlexColumn>
    </TextWrapper>
  </Container>
);

export default TicketReference;
